import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import type { DocumentNode } from '@marvr/storyblok-rich-text-types'
import { createRenderer } from './rendered'
import type { ComponentResolverFunction } from './resolvers'
import { defaultResolvers } from './resolvers'

export default defineComponent({
  name: 'RichTextRenderer',
  props: {
    document: {
      type: Object as PropType<DocumentNode>,
      required: true,
    },
  },
  setup(props) {
    const componentResolvers = (): ComponentResolvers => {
      const res = {} as ComponentResolvers
      useAppConfig().richTextComponents.forEach((options) => {
        res[options.name] = ({ fields }) => h(resolveComponent(options.component), { ...options.props, ...fields })
      })
      return res
    }

    const renderer = createRenderer({ ...defaultResolvers, components: componentResolvers() })
    return () => renderer.renderDocument(props.document)
  },
})

type ComponentResolvers = Record<string, ComponentResolverFunction>
